import useCustomRouter from '@/hooks/useCustomRouter';
import { addQueryString } from '@/utils/url';
import { useCallback } from 'react';

const useUserVerificationGuideViewModel = () => {
  const { router } = useCustomRouter();

  const redirectUrl = (router.query.redirectUrl as string) || '/';

  const handleBack = useCallback(() => {
    router.back();
  }, [router]);

  const handleCertification = useCallback(() => {
    router.push(
      '/phone-verification' +
        addQueryString({
          redirectUrl,
        })
    );
  }, [router, redirectUrl]);

  return {
    handleBack,
    handleCertification,
  };
};

export default useUserVerificationGuideViewModel;
